import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import react, { useState } from "react";
import { ButtonChip, Link, Text } from "pcln-design-system";
import { Globe } from "pcln-icons";
const handleClick = ({ setIsOpened, isOpened })=>function(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsOpened(!isOpened);
    };
const CitationsSources = (props)=>{
    const [isOpened, setIsOpened] = useState(false);
    const { webSearchResult } = props;
    const numberOfCitations = webSearchResult.length;
    const chipProps = {
        fontWeight: 'bold',
        label: 'Sources',
        facet: `(${numberOfCitations})`,
        Icon: Globe,
        expanded: isOpened,
        showActionIcon: true
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(ButtonChip, {
                ...chipProps,
                size: "sm",
                my: 1,
                onClick: handleClick({
                    isOpened,
                    setIsOpened
                })
            }),
            isOpened && /*#__PURE__*/ jsx(react.Fragment, {
                children: webSearchResult.map((result, index)=>{
                    const url = new URL(result.url);
                    const host = url.host;
                    return /*#__PURE__*/ jsx(react.Fragment, {
                        children: /*#__PURE__*/ jsxs(Text, {
                            fontSize: 0,
                            children: [
                                /*#__PURE__*/ jsxs(Text.span, {
                                    children: [
                                        result.citationNumber,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ jsx(Link, {
                                    href: result.url,
                                    target: "_blank",
                                    children: result.webPageName
                                }),
                                /*#__PURE__*/ jsx(Text.span, {
                                    ml: 1,
                                    color: "text.light",
                                    children: host
                                })
                            ]
                        })
                    }, `Web-search-res-${index}`);
                })
            })
        ]
    });
};
CitationsSources.displayName = 'CitationsSources';
export { CitationsSources };
